import React from "react";
import { Await, useLoaderData, useNavigation } from "react-router-dom";
import { LoaderData } from "../MyAccount";
import { finesLoader } from "./finesLoader";
import { FinesSharedView } from "./FinesSharedView";
import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import axios from "axios";
import { FinesSkeltons } from "./FinesSkeltons";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import { convertPenniesToCurrency } from "@tlc/ls2pac/components/AccountMenu";
import { useAccount } from "@tlc/ls2pac/components/Account";
import { useErrorDialog } from "@tlc/ui/dialog/error/ErrorDialogContext";

export const BorrowerFinesView: React.FC = () => {
  const { data, pageSize } = useLoaderData() as LoaderData<typeof finesLoader>;
  const navigation = useNavigation();
  const { accountSummary } = useAccount();
  const { locationConfiguration } = useLocationConfiguration();
  const { handleRequestError } = useErrorDialog();
  const ecommerceEnabled =
    locationConfiguration?.pacSettings.ecommerceEnabled || false;
  const feesTotalAmount = convertPenniesToCurrency(accountSummary?.fees);

  // Get all fines for printing
  const getAllFinesSortable = async (
    page: number,
    count: number,
    sortType: HostSystemItemSortType,
    refreshToken: number,
  ): Promise<HostSystemItemView[]> => {
    const allFeesResponse: HostSystemItemView[] = await axios
      .get(`/fees/${page * count}/${count}/${sortType}?_=${refreshToken}`)
      .then((res) => {
        return res.data.fees;
      })
      .catch((error) => {
        handleRequestError(error);
      });

    return allFeesResponse;
  };

  return (
    <React.Suspense
      fallback={
        <FinesSkeltons
          hideActions={false}
          pageSize={pageSize}
          ecommerceEnabled={ecommerceEnabled}
        />
      }
    >
      <Await resolve={data}>
        {({ sort, page, pageSize, fees, feesTotalCount, refreshToken }) => {
          return (
            <FinesSharedView
              page={page}
              pageSize={pageSize}
              sort={sort}
              isStudent={false}
              fees={fees}
              feesTotalCount={feesTotalCount}
              feesTotalAmount={feesTotalAmount}
              routeIsLoading={navigation.state === "loading"}
              ecommerceEnabled={ecommerceEnabled}
              fetchPrintFines={async () => {
                const response = await getAllFinesSortable(
                  0,
                  feesTotalCount,
                  sort,
                  refreshToken,
                );
                return response;
              }}
            />
          );
        }}
      </Await>
    </React.Suspense>
  );
};
